import { createGlobalReferenceContext } from '@flex-packages/shared-react';
import { runtimeEnvInitialValue, buildtimeEnvInitialValue } from './initialValue.mjs';

const EnvContext = createGlobalReferenceContext("env-context", {
  env: {
    buildtime: buildtimeEnvInitialValue,
    runtime: runtimeEnvInitialValue
  }
});

export { EnvContext };
//# sourceMappingURL=EnvContext.mjs.map
